import { render, staticRenderFns } from "./RegularTables.vue?vue&type=template&id=e79ad7f0&scoped=true&"
import script from "./RegularTables.vue?vue&type=script&lang=js&"
export * from "./RegularTables.vue?vue&type=script&lang=js&"
import style0 from "./RegularTables.vue?vue&type=style&index=0&id=e79ad7f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79ad7f0",
  null
  
)

component.options.__file = "RegularTables.vue"
export default component.exports